import axios from 'axios';

const StripeAPI = {};
StripeAPI.getPublishKey = async () => (await axios.get(`${process.env.VUE_APP_API}/1/stripe/pkey`)).data;
StripeAPI.getProduct = async (productId) => (await axios.get(`${process.env.VUE_APP_API}/1/stripe/product/${productId}`)).data;
StripeAPI.getPlan = async (planNickname) => (await axios.get(`${process.env.VUE_APP_API}/1/stripe/plan/${planNickname}`)).data;

export default StripeAPI;
